(function () {
  const FOCUSABLE = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

  function initUgc(root) {
    if (!root || root.dataset.peggellUgcReady === 'true') return;
    root.dataset.peggellUgcReady = 'true';

    const modal = root.querySelector('[data-peggell-ugc-modal]');
    const player = root.querySelector('[data-peggell-ugc-player]');
    if (!modal || !player) return;

    const closeEls = modal.querySelectorAll('[data-peggell-ugc-close]');
    let lastFocus = null;
    let modalParent = null;
    let modalNext = null;

    function stopVideo() {
      const video = player.querySelector('video');
      if (video) {
        video.pause();
      }
      player.innerHTML = '';
    }

    function closeModal() {
      if (modal.hasAttribute('hidden')) return;
      stopVideo();
      modal.setAttribute('hidden', '');
      document.body.classList.remove('overflow-hidden');

      if (modalParent) {
        if (modalNext && modalNext.parentNode === modalParent) {
          modalParent.insertBefore(modal, modalNext);
        } else {
          modalParent.appendChild(modal);
        }
        modalParent = null;
        modalNext = null;
      }

      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    function openModal(trigger) {
      const template = trigger.querySelector('[data-peggell-ugc-video]');
      if (!template) return;

      lastFocus = trigger;
      stopVideo();

      if (modal.parentElement !== document.body) {
        modalParent = modal.parentElement;
        modalNext = modal.nextSibling;
        document.body.appendChild(modal);
      }

      player.appendChild(template.content.cloneNode(true));

      const video = player.querySelector('video');
      if (video) {
        video.setAttribute('playsinline', '');
        video.controls = true;
        video.muted = false;
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      }

      modal.removeAttribute('hidden');
      document.body.classList.add('overflow-hidden');

      const closeBtn = modal.querySelector('.product__ugc-modal-close');
      if (closeBtn) closeBtn.focus();
    }

    root.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-peggell-ugc-open]');
      if (!trigger || !root.contains(trigger)) return;
      event.preventDefault();
      openModal(trigger);
    });

    closeEls.forEach((el) => {
      el.addEventListener('click', (event) => {
        event.preventDefault();
        closeModal();
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hasAttribute('hidden')) {
        closeModal();
      }
    });

    modal.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab' || modal.hasAttribute('hidden')) return;
      const focusables = Array.from(modal.querySelectorAll(FOCUSABLE)).filter((el) => {
        return !el.hasAttribute('disabled') && el.getClientRects().length > 0;
      });
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-peggell-ugc]').forEach(initUgc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
